import { PluginKey, TextSelection, Plugin } from 'prosemirror-state';
import { NodeExtension } from '../../../core/index.js';
import 'prosemirror-commands';
import 'prosemirror-inputrules';
import 'prosemirror-model';
import { DecorationSet, Decoration } from 'prosemirror-view';
import { v4 } from 'uuid';
import React, { Component } from 'react';
import cn from 'classnames';
import ReactDOM from 'react-dom';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var ZERO_WIDTH_SPACE = "​";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
/**
 * 格式化文件大小(File.size)，加上单位
 */ function formatFileSize(origin) {
    if (origin >= 1024 * 1024) {
        return "".concat((origin / (1024 * 1024)).toFixed(2), "MB");
    }
    if (origin >= 1024) {
        return "".concat((origin / 1024).toFixed(2), "KB");
    }
    return "".concat(origin || 0, "B");
}

// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var optionsMerge = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var res = _objectSpread({}, target, source);
    if (source.state) {
        res.state = optionsMerge(target.state, source.state);
    }
    if (source.props) {
        res.props = optionsMerge(target.props, source.props);
    }
    return res;
};
function UploaderOption(pluginOption, param) {
    var createUploadMask = param.createUploadMask;
    var uploaderOption = {
        state: {
            init: function init() {
                return DecorationSet.empty;
            },
            apply: function apply(tr, set) {
                // Adjust decoration positions to changes made by the transaction
                set = set.map(tr.mapping, tr.doc);
                // See if the transaction adds or removes any placeholders
                var action = tr.getMeta(this);
                if (action && action.add) {
                    var widget = createUploadMask(action.add, action.add.id);
                    var deco = Decoration.widget(action.add.pos, widget, {
                        id: action.add.id,
                        ignoreSelection: true
                    });
                    set = set.add(tr.doc, [
                        deco
                    ]);
                } else if (action && action.remove) {
                    set = set.remove(set.find(null, null, function(spec) {
                        return spec.id === action.remove.id;
                    }));
                }
                return set;
            }
        },
        props: {
            decorations: function decorations(state) {
                return this.getState(state);
            }
        }
    };
    return optionsMerge(pluginOption, uploaderOption);
}

var pluginKey = new PluginKey("attachment");

var AFTER_INSERT = "after_insert";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var __generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 参考自官网Demo：https://prosemirror.net/examples/upload/
 */ function findPlaceholder(view, id) {
    var decos = pluginKey.getState(view.state);
    var found = decos.find(null, null, function(spec) {
        return spec.id === id;
    });
    if (found.length) {
        return {
            pos: found[0].from,
            node: found[0].type.toDOM
        };
    }
    return null;
}
var onUpload = function(param) {
    var view = param.view, provider = param.provider, idMap = param.idMap, eventEmitter = param.eventEmitter, nodeType = param.nodeType, _param_pos = param.pos, pos = _param_pos === void 0 ? null : _param_pos;
    var getComponent = function(id) {
        return idMap[id];
    };
    return function() {
        var _ref = _asyncToGenerator(function(file) {
            var customUpload, _view_state, tr, schema, attachment, id, ret, attrs, _nodeType_spec_braceWidth, onProgress, data, _tmp, placeholder, e, placeholder1, comp;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customUpload = typeof file === "function" ? file : null;
                        _view_state = view.state, tr = _view_state.tr, schema = _view_state.schema;
                        attachment = schema.nodes.attachment;
                        id = v4();
                        if (!provider.beforeUpload) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            provider.beforeUpload(file, id)
                        ];
                    case 1:
                        ret = _state.sent();
                        // 只有当校验函数显示返回 false 时才表示校验不通过
                        if (ret === false) {
                            view.focus();
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        attrs = {
                            name: file.name || ""
                        };
                        if (typeof pos !== "number") pos = tr.selection.from;
                        if (!tr.selection.empty) {
                            tr.deleteSelection();
                        }
                        tr.setMeta(pluginKey, {
                            add: {
                                id: id,
                                pos: pos,
                                file: file
                            }
                        });
                        // 为了能够在placeholder后面输入文字
                        tr.setSelection(TextSelection.create(tr.doc, pos)).insertText(ZERO_WIDTH_SPACE, pos).setSelection(TextSelection.create(tr.doc, pos + 1));
                        view.dispatch(tr);
                        eventEmitter.emit(AFTER_INSERT, {
                            braceWidth: (_nodeType_spec_braceWidth = nodeType.spec.braceWidth) !== null && _nodeType_spec_braceWidth !== void 0 ? _nodeType_spec_braceWidth : 340,
                            pos: pos
                        }); // 如果在表格中，更新列宽
                        onProgress = function(param) {
                            var loaded = param.loaded, total = param.total;
                            var placeholder = findPlaceholder(view, id);
                            if (!placeholder) return;
                            var percent = Math.ceil(total ? loaded / total * 99 : 0);
                            var comp = getComponent(id);
                            comp && comp.setProgress(percent);
                        };
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            8,
                            ,
                            9
                        ]);
                        if (!customUpload) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            customUpload()
                        ];
                    case 4:
                        _tmp = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            provider.upload(file, onProgress)
                        ];
                    case 6:
                        _tmp = _state.sent();
                        _state.label = 7;
                    case 7:
                        data = _tmp;
                        placeholder = findPlaceholder(view, id);
                        // If the content around the placeholder has been deleted, drop
                        // the image
                        if (!placeholder) return [
                            2
                        ];
                        // Otherwise, insert it at the placeholder's position, and remove
                        // the placeholder
                        if (data.size) {
                            data.size = formatFileSize(data.size);
                        }
                        // 删除 state 中保存的 placeholder
                        view.dispatch(view.state.tr.replaceRangeWith(placeholder.pos, placeholder.pos + 1, attachment.create(_objectSpread$1({}, attrs, data))).setMeta(pluginKey, {
                            remove: {
                                id: id
                            }
                        }));
                        // 插入音频宏
                        // TODO:暂时不用insertBlock的实现，会导致插入视频后移动光标，视频上传完成后在光标的位置而不是placeholder的位置
                        // insertAttachment({ ...attrs, ...data })(view.state, view.dispatch, view);
                        delete idMap[id];
                        return [
                            3,
                            9
                        ];
                    case 8:
                        e = _state.sent();
                        console.error("上传失败", e);
                        placeholder1 = findPlaceholder(view, id);
                        if (!placeholder1) return [
                            2
                        ];
                        comp = getComponent(id);
                        comp.onRetry = function() {
                            var _view_state = view.state, retryTr = _view_state.tr;
                            view.dispatch(retryTr.setMeta(pluginKey, {
                                remove: {
                                    id: id
                                }
                            }).delete(placeholder1.pos, placeholder1.pos + 1).setSelection(TextSelection.create(retryTr.doc, placeholder1.pos)));
                            onUpload({
                                view: view,
                                provider: provider,
                                idMap: idMap,
                                pos: placeholder1.pos,
                                eventEmitter: eventEmitter,
                                nodeType: nodeType
                            })(file);
                        };
                        comp && comp.setHasError(true);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }();
};
var selectFile = function(param) {
    var accept = param.accept, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? true : _param_multiple;
    return new Promise(function(resolve) {
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        if (multiple) {
            input.setAttribute("multiple", "multiple");
        }
        input.setAttribute("accept", accept);
        input.onchange = function(e) {
            var files = e.target.files;
            input.remove();
            resolve(files);
        };
        input.click();
    });
};

var AttachmentView = function(props) {
    var attrs = props.attrs, provider = props.provider;
    var name = attrs.name, size = attrs.size, src = attrs.src;
    var doCopy = function() {
        provider && provider.copy(src);
    };
    var doDownload = function() {
        provider && provider.download(src, name);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(classNamePrefix("attachment"), {
            "align-right": (attrs === null || attrs === void 0 ? void 0 : attrs.align) === "right"
        }),
        spellCheck: false,
        contentEditable: false
    }, /*#__PURE__*/ React.createElement("div", {
        className: "attachment-icon"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "name"
    }, name), /*#__PURE__*/ React.createElement("div", {
        className: "size"
    }, size)), /*#__PURE__*/ React.createElement("div", {
        className: "copy",
        onClick: doCopy
    }, /*#__PURE__*/ React.createElement("div", {
        className: "btn-copy"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "download",
        onClick: doDownload
    }, /*#__PURE__*/ React.createElement("div", {
        className: "btn-download"
    })));
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ErrorIcon = /*#__PURE__*/ function(Component) {
    _inherits(ErrorIcon, Component);
    var _super = _createSuper(ErrorIcon);
    function ErrorIcon() {
        _classCallCheck(this, ErrorIcon);
        return _super.apply(this, arguments);
    }
    var _proto = ErrorIcon.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("svg", {
            width: "16px",
            height: "16px",
            viewBox: "0 0 16 16",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink"
        }, /*#__PURE__*/ React.createElement("g", {
            stroke: "none"
        }, /*#__PURE__*/ React.createElement("g", {
            transform: "translate(-296.000000, -544.000000)",
            fill: "#F05E50"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M304,544 C308.41824,544 312,547.58176 312,552 C312,556.41824 308.41824,560 304,560 C299.58176,560 296,556.41824 296,552 C296,547.58176 299.58176,544 304,544 Z M299.2,552 C299.2,552.667362 299.735663,553.2 300.396436,553.2 L307.603564,553.2 C308.256356,553.2 308.8,552.662742 308.8,552 C308.8,551.332638 308.264337,550.8 307.603564,550.8 L300.396436,550.8 C299.743644,550.8 299.2,551.337258 299.2,552 Z",
            id: "tost-错误"
        }))));
    };
    return ErrorIcon;
}(Component);

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-attachment-placeholder{position:relative;display:flex;min-width:320px;max-width:340px;height:56px;line-height:1;padding:8px 12px;margin:2px 0;background:#f6f6f6;border:1px solid #ddd;border-radius:2px;outline:none;text-decoration:none;box-sizing:border-box;cursor:pointer}.ct-attachment-placeholder[data-type=ct-progress]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-attachment-placeholder.selected,.ct-attachment-placeholder:hover{border-color:#3d91f2}.ct-attachment-placeholder:active{border:1px solid #0082a6}.ct-attachment-placeholder .attachment-icon{width:24px;height:34px;flex-shrink:0;background:url("data:image/svg+xml,%3Csvg width%3D%2224px%22 height%3D%2223px%22 viewBox%3D%220 0 24 23%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22%3E        %3Cg transform%3D%22translate(-688.000000%2C -866.000000)%22%3E            %3Cg transform%3D%22translate(685.000000%2C 862.000000)%22%3E                %3Crect id%3D%22Rectangle-17%22 fill-opacity%3D%220%22 fill%3D%22%23F6F6F6%22 x%3D%220%22 y%3D%220%22 width%3D%2230%22 height%3D%2230%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Cpath d%3D%22M6.49853365%2C14.6639779 C4.13913438%2C17.0174106 4.14092301%2C20.8348631 6.50032228%2C23.1882958 C8.75896153%2C25.4412232 12.0047027%2C25.1820314 14.3780845%2C23.1215301 L24.2770726%2C13.2475751 C25.6468437%2C11.8812679 25.6468437%2C9.66604628 24.2770726%2C8.29973911 C22.9073015%2C6.93343194 20.6864637%2C6.93343194 19.3166926%2C8.29973911 L9.20862255%2C18.3822474 C8.72882633%2C18.9698239 8.76335668%2C19.8360463 9.31221361%2C20.3835153 C9.89791917%2C20.9677397 10.8475355%2C20.9677397 11.433241%2C20.3835153 L19.814834%2C12.0231181 C20.1190587%2C11.7450807 20.5916516%2C11.7477221 20.8841528%2C12.0394836 C21.176654%2C12.3312451 21.1793021%2C12.8026429 20.892097%2C13.097657 L12.3408139%2C21.6274323 C11.1601199%2C22.8051404 9.24583685%2C22.8051404 8.06514292%2C21.6274323 C6.884449%2C20.4497242 6.884449%2C18.540282 8.06514292%2C17.3625739 L7.70883701%2C17.7179788 L18.3980144%2C7.05583277 C20.3658376%2C5.09298589 23.5563094%2C5.09298589 25.5241326%2C7.05583277 C27.4919558%2C9.01867965 27.4919558%2C12.2010832 25.5241326%2C14.1639301 L14.8349552%2C24.8260761 L15.1912612%2C24.4706713 C12.2106117%2C27.0546925 8.04670149%2C27.2955154 5.21469563%2C24.4706713 C2.26296081%2C21.5264009 2.26117218%2C16.7510115 5.212907%2C13.8067411 L15.5457784%2C3.5 L14.1205548%2C4.92161947 C14.4186199%2C4.66321957 14.8706399%2C4.67467844 15.1538398%2C4.95716212 C15.4370396%2C5.2396458 15.4485275%2C5.69052271 15.1883035%2C5.98666804 L6.49853365%2C14.6639779 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23BDC2C7%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.ct-attachment-placeholder .content{margin-left:12px;width:calc(100% - 100px)}.ct-attachment-placeholder .name{line-height:18px;font-size:12px;color:#333;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ct-attachment-placeholder .bottom{margin-top:8px;font-size:12px;color:#999}.ct-attachment-placeholder .bottom .upload-size{margin-left:8px;line-height:12px}.ct-attachment-placeholder .bottom .upload-percent{margin-left:8px}.ct-attachment-placeholder .progress-wrapper{display:inline-block;position:relative;width:100px;height:8px;border:1px solid #ddd;border-radius:6px;background-color:hsla(0,0%,86.7%,0)}.ct-attachment-placeholder .progress{position:absolute;top:-1px;left:0;height:8px;border:1px solid #0082a6;box-shadow:0 2px 8px 0 rgba(71,134,255,.24);border-radius:6px;background-color:#0082a6}.ct-attachment-placeholder .retry{display:flex;align-items:center;margin-left:24px;font-size:14px;color:#666}.ct-attachment-placeholder .retry .retry-btn{margin-left:5px;cursor:pointer;color:#4b89fc}.ct-attachment-placeholder .retry .retry-btn:hover{color:#108ee9}.ct-attachment-placeholder.has-error{height:48px;align-items:center;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-attachment-placeholder.has-error:hover{border-color:#23bdd9}.ct-attachment-placeholder.has-error .attachment-icon{height:30px}.ct-attachment-placeholder.has-error .content{width:auto}.ct-attachment-placeholder.has-error .content .name{max-width:115px}';
styleInject(css_248z);

function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var Placeholder = /*#__PURE__*/ function(_React_Component) {
    _inherits$1(Placeholder, _React_Component);
    var _super = _createSuper$1(Placeholder);
    function Placeholder() {
        _classCallCheck$1(this, Placeholder);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            progress: 0,
            hasError: false
        };
        _this.onRetry = null;
        // 修改进度
        _this.setProgress = function(progress) {
            _this.setState({
                progress: progress
            });
        };
        // 修改错误状态
        _this.setHasError = function(hasError) {
            _this.setState({
                hasError: hasError
            });
        };
        // 重新上传
        _this.retry = function() {
            var onRetry = _assertThisInitialized$1(_this).onRetry;
            _this.setState({
                hasError: false
            }, function() {
                return onRetry && onRetry();
            });
        };
        return _this;
    }
    var _proto = Placeholder.prototype;
    _proto.render = function render() {
        var _this_props = this.props, name = _this_props.name, size = _this_props.size;
        var _this_state = this.state, progress = _this_state.progress, hasError = _this_state.hasError;
        return /*#__PURE__*/ React.createElement("div", {
            className: "".concat(classNamePrefix("attachment-placeholder"), " ").concat(hasError ? "has-error" : ""),
            "data-type": "ct-progress",
            spellCheck: false,
            contentEditable: false
        }, /*#__PURE__*/ React.createElement("div", {
            className: "attachment-icon"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "content"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "name"
        }, name), !hasError && /*#__PURE__*/ React.createElement("div", {
            className: "bottom"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "progress-wrapper"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "progress",
            style: {
                width: progress
            }
        })), /*#__PURE__*/ React.createElement("span", {
            className: "upload-size"
        }, size), /*#__PURE__*/ React.createElement("span", {
            className: "upload-percent"
        }, progress, "%"))), hasError && /*#__PURE__*/ React.createElement("div", {
            className: "retry"
        }, /*#__PURE__*/ React.createElement(ErrorIcon, null), /*#__PURE__*/ React.createElement("span", {
            className: "upload-error-msg"
        }, /*#__PURE__*/ React.createElement("span", null, "上传失败，"), /*#__PURE__*/ React.createElement("span", {
            className: "retry-btn",
            onClick: this.retry
        }, "重试"))));
    };
    return Placeholder;
}(React.Component);

/**
 * 创建上传文件占位区域
 * @param url 本地文件地址
 */ var createPlaceholder = function(idMap) {
    return function(param, id) {
        var file = param.file;
        var widget = document.createElement("div");
        var name = file.name;
        // 渲染组件，并将组件的实例存入 store 中，以 id 为 key
        ReactDOM.render(/*#__PURE__*/ React.createElement(Placeholder, {
            id: id,
            name: name,
            file: file,
            size: formatFileSize(file.size),
            ref: function(ref) {
                idMap[id] = ref;
            }
        }), widget);
        return widget;
    };
};

var css_248z$1 = '.pk-view-container .ct-attachment,.ProseMirror .ct-attachment{position:relative;display:flex;min-width:200px;max-width:340px;height:56px;line-height:1;padding:8px 12px;margin:2px 0;background:#f6f6f6;border:1px solid #ddd;border-radius:2px;outline:none;text-decoration:none;box-sizing:border-box;cursor:pointer}.pk-view-container .ct-attachment:active,.ProseMirror .ct-attachment:active{border:1px solid #0082a6}.pk-view-container .ct-attachment:hover,.ProseMirror .ct-attachment:hover{border-color:#3d91f2}.pk-view-container .ct-attachment.align-right,.ProseMirror .ct-attachment.align-right{width:320px}.pk-view-container .ct-attachment .attachment-icon,.ProseMirror .ct-attachment .attachment-icon{width:24px;height:34px;background:url("data:image/svg+xml,%3Csvg width%3D%2224px%22 height%3D%2223px%22 viewBox%3D%220 0 24 23%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22%3E        %3Cg transform%3D%22translate(-688.000000%2C -866.000000)%22%3E            %3Cg transform%3D%22translate(685.000000%2C 862.000000)%22%3E                %3Crect id%3D%22Rectangle-17%22 fill-opacity%3D%220%22 fill%3D%22%23F6F6F6%22 x%3D%220%22 y%3D%220%22 width%3D%2230%22 height%3D%2230%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Cpath d%3D%22M6.49853365%2C14.6639779 C4.13913438%2C17.0174106 4.14092301%2C20.8348631 6.50032228%2C23.1882958 C8.75896153%2C25.4412232 12.0047027%2C25.1820314 14.3780845%2C23.1215301 L24.2770726%2C13.2475751 C25.6468437%2C11.8812679 25.6468437%2C9.66604628 24.2770726%2C8.29973911 C22.9073015%2C6.93343194 20.6864637%2C6.93343194 19.3166926%2C8.29973911 L9.20862255%2C18.3822474 C8.72882633%2C18.9698239 8.76335668%2C19.8360463 9.31221361%2C20.3835153 C9.89791917%2C20.9677397 10.8475355%2C20.9677397 11.433241%2C20.3835153 L19.814834%2C12.0231181 C20.1190587%2C11.7450807 20.5916516%2C11.7477221 20.8841528%2C12.0394836 C21.176654%2C12.3312451 21.1793021%2C12.8026429 20.892097%2C13.097657 L12.3408139%2C21.6274323 C11.1601199%2C22.8051404 9.24583685%2C22.8051404 8.06514292%2C21.6274323 C6.884449%2C20.4497242 6.884449%2C18.540282 8.06514292%2C17.3625739 L7.70883701%2C17.7179788 L18.3980144%2C7.05583277 C20.3658376%2C5.09298589 23.5563094%2C5.09298589 25.5241326%2C7.05583277 C27.4919558%2C9.01867965 27.4919558%2C12.2010832 25.5241326%2C14.1639301 L14.8349552%2C24.8260761 L15.1912612%2C24.4706713 C12.2106117%2C27.0546925 8.04670149%2C27.2955154 5.21469563%2C24.4706713 C2.26296081%2C21.5264009 2.26117218%2C16.7510115 5.212907%2C13.8067411 L15.5457784%2C3.5 L14.1205548%2C4.92161947 C14.4186199%2C4.66321957 14.8706399%2C4.67467844 15.1538398%2C4.95716212 C15.4370396%2C5.2396458 15.4485275%2C5.69052271 15.1883035%2C5.98666804 L6.49853365%2C14.6639779 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23BDC2C7%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.pk-view-container .ct-attachment .content,.ProseMirror .ct-attachment .content{margin-left:12px;width:calc(100% - 100px)}.pk-view-container .ct-attachment .name,.ProseMirror .ct-attachment .name{line-height:18px;font-size:12px;color:#333;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.pk-view-container .ct-attachment .size,.ProseMirror .ct-attachment .size{display:inline-block;line-height:12px;font-size:12px;color:#999}.pk-view-container .ct-attachment .copy,.ProseMirror .ct-attachment .copy{position:absolute;top:15px;right:30px;bottom:0;width:40px}.pk-view-container .ct-attachment .copy .btn-copy,.ProseMirror .ct-attachment .copy .btn-copy{height:100%;border-left:1px solid #ddd;margin:-7px 0;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%80%9A%E7%94%A8%E7%BB%84%E4%BB%B6%E8%A7%84%E8%8C%83%E5%92%8C%E6%A1%88%E4%BE%8Bv0.1-%E5%9B%BE%E6%A0%87%E6%96%87%E6%A1%88%E9%97%B4%E8%B7%9D%22 transform%3D%22translate(-496.000000%2C -986.000000)%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E            %3Cg id%3D%22%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(496.000000%2C 986.000000)%22%3E                %3Cpath d%3D%22M11.6008309%2C1 C12.8995343%2C1.07592189 14.0703003%2C1.71698456 14.6762067%2C3.14250056 C15.2917537%2C4.59090718 15.0177693%2C5.93811066 13.955644%2C7.08887658 C13.2036907%2C7.90225179 12.3962373%2C8.66503324 11.6068778%2C9.44345532 C11.2640964%2C9.78206478 10.7149244%2C9.79290854 10.4180024%2C9.4808147 C10.1174711%2C9.16509587 10.1500649%2C8.73129889 10.51094%2C8.36859567 C11.2858152%2C7.59136109 12.0715654%2C6.82378276 12.8379718%2C6.03932944 C13.9930503%2C4.85721975 13.480097%2C2.97740676 11.8844716%2C2.55323478 C11.2206433%2C2.37731286 10.5833619%2C2.49901601 10.0788461%2C2.96896926 C9.26654902%2C3.72451633 8.5025332%2C4.52945404 7.69386112%2C5.28620424 C7.52248607%2C5.44646991 7.23884537%2C5.58503244 7.01675156%2C5.57057931 C6.42172016%2C5.53442305 6.12118883%2C4.81382912 6.53276706%2C4.38486026 C7.41747042%2C3.46303189 8.32028315%2C2.55565665 9.27017403%2C1.70251581 C9.8483148%2C1.1831563 10.6014712%2C1.0048125 11.6008309%2C1 Z M1%2C11.4027996 C1.00603125%2C10.4086743 1.35243759%2C9.54950222 2.04885965%2C8.84095516 C2.8177036%2C8.05770496 3.59861005%2C7.28650163 4.37831338%2C6.51409518 C4.74886035%2C6.14656384 5.20389172%2C6.11886071 5.51768867%2C6.43456391 C5.84357938%2C6.76353275 5.81220438%2C7.17804848 5.4259699%2C7.56606421 C4.68367283%2C8.3107519 3.92932889%2C9.04581459 3.19428182%2C9.79893979 C2.28542221%2C10.7280025 2.2467972%2C11.9823935 3.08443804%2C12.8247062 C3.88587575%2C13.630847 5.21112609%2C13.6344564 6.04876694%2C12.8186749 C6.81036089%2C12.0763935 7.5514392%2C11.3124246 8.31064253%2C10.5689244 C8.76686139%2C10.1230805 9.45967407%2C10.282143 9.58036161%2C10.8822369 C9.62381474%2C11.0979245 9.53692409%2C11.423284 9.38723656%2C11.5811434 C8.56168947%2C12.4511436 7.73731425%2C13.3283938 6.83812652%2C14.1176597 C5.73736061%2C15.0840662 4.44711027%2C15.2443475 3.10254742%2C14.6587067 C1.80264083%2C14.0923628 1.003625%2C12.8162687 1%2C11.4028152 L1%2C11.4027996 Z M11.0709714%2C5.73326686 C11.0226901%2C5.82362625 10.9671745%2C6.01884505 10.8416588%2C6.14656384 C9.32690841%2C7.68415799 7.80611114%2C9.21450214 6.27809512%2C10.7376275 C5.95340754%2C11.0617839 5.49114179%2C11.0400807 5.18578234%2C10.7316119 C4.87800101%2C10.4207212 4.88645414%2C9.99414296 5.22921985%2C9.64951787 C6.72950149%2C8.14567373 8.23459563%2C6.64545459 9.73848665%2C5.14642295 C9.98228359%2C4.90300101 10.2683305%2C4.80057911 10.6014556%2C4.9451729 C10.8983776%2C5.07411043 11.0492526%2C5.310298 11.070987%2C5.73325123 L11.0709714%2C5.73326686 Z%22 id%3D%22Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 13px;background-position:10px}.pk-view-container .ct-attachment .copy .btn-copy:hover,.ProseMirror .ct-attachment .copy .btn-copy:hover{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%80%9A%E7%94%A8%E7%BB%84%E4%BB%B6%E8%A7%84%E8%8C%83%E5%92%8C%E6%A1%88%E4%BE%8Bv0.1-%E5%9B%BE%E6%A0%87%E6%96%87%E6%A1%88%E9%97%B4%E8%B7%9D%22 transform%3D%22translate(-496.000000%2C -986.000000)%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E            %3Cg id%3D%22%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(496.000000%2C 986.000000)%22 fill%3D%22%233d91f2%22%3E                %3Cpath d%3D%22M11.6008309%2C1 C12.8995343%2C1.07592189 14.0703003%2C1.71698456 14.6762067%2C3.14250056 C15.2917537%2C4.59090718 15.0177693%2C5.93811066 13.955644%2C7.08887658 C13.2036907%2C7.90225179 12.3962373%2C8.66503324 11.6068778%2C9.44345532 C11.2640964%2C9.78206478 10.7149244%2C9.79290854 10.4180024%2C9.4808147 C10.1174711%2C9.16509587 10.1500649%2C8.73129889 10.51094%2C8.36859567 C11.2858152%2C7.59136109 12.0715654%2C6.82378276 12.8379718%2C6.03932944 C13.9930503%2C4.85721975 13.480097%2C2.97740676 11.8844716%2C2.55323478 C11.2206433%2C2.37731286 10.5833619%2C2.49901601 10.0788461%2C2.96896926 C9.26654902%2C3.72451633 8.5025332%2C4.52945404 7.69386112%2C5.28620424 C7.52248607%2C5.44646991 7.23884537%2C5.58503244 7.01675156%2C5.57057931 C6.42172016%2C5.53442305 6.12118883%2C4.81382912 6.53276706%2C4.38486026 C7.41747042%2C3.46303189 8.32028315%2C2.55565665 9.27017403%2C1.70251581 C9.8483148%2C1.1831563 10.6014712%2C1.0048125 11.6008309%2C1 Z M1%2C11.4027996 C1.00603125%2C10.4086743 1.35243759%2C9.54950222 2.04885965%2C8.84095516 C2.8177036%2C8.05770496 3.59861005%2C7.28650163 4.37831338%2C6.51409518 C4.74886035%2C6.14656384 5.20389172%2C6.11886071 5.51768867%2C6.43456391 C5.84357938%2C6.76353275 5.81220438%2C7.17804848 5.4259699%2C7.56606421 C4.68367283%2C8.3107519 3.92932889%2C9.04581459 3.19428182%2C9.79893979 C2.28542221%2C10.7280025 2.2467972%2C11.9823935 3.08443804%2C12.8247062 C3.88587575%2C13.630847 5.21112609%2C13.6344564 6.04876694%2C12.8186749 C6.81036089%2C12.0763935 7.5514392%2C11.3124246 8.31064253%2C10.5689244 C8.76686139%2C10.1230805 9.45967407%2C10.282143 9.58036161%2C10.8822369 C9.62381474%2C11.0979245 9.53692409%2C11.423284 9.38723656%2C11.5811434 C8.56168947%2C12.4511436 7.73731425%2C13.3283938 6.83812652%2C14.1176597 C5.73736061%2C15.0840662 4.44711027%2C15.2443475 3.10254742%2C14.6587067 C1.80264083%2C14.0923628 1.003625%2C12.8162687 1%2C11.4028152 L1%2C11.4027996 Z M11.0709714%2C5.73326686 C11.0226901%2C5.82362625 10.9671745%2C6.01884505 10.8416588%2C6.14656384 C9.32690841%2C7.68415799 7.80611114%2C9.21450214 6.27809512%2C10.7376275 C5.95340754%2C11.0617839 5.49114179%2C11.0400807 5.18578234%2C10.7316119 C4.87800101%2C10.4207212 4.88645414%2C9.99414296 5.22921985%2C9.64951787 C6.72950149%2C8.14567373 8.23459563%2C6.64545459 9.73848665%2C5.14642295 C9.98228359%2C4.90300101 10.2683305%2C4.80057911 10.6014556%2C4.9451729 C10.8983776%2C5.07411043 11.0492526%2C5.310298 11.070987%2C5.73325123 L11.0709714%2C5.73326686 Z%22 id%3D%22Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.pk-view-container .ct-attachment .download,.ProseMirror .ct-attachment .download{position:absolute;top:15px;right:0;bottom:0;width:30px}.pk-view-container .ct-attachment .download .btn-download,.ProseMirror .ct-attachment .download .btn-download{margin-top:-7px;width:30px;height:100%;display:inline-block;border-left:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2214px%22 height%3D%2214px%22 viewBox%3D%220 0 14 14%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E4%B8%8B%E8%BD%BD copy%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%99%84%E4%BB%B6%E6%B7%BB%E5%8A%A0%E5%A4%8D%E5%88%B6%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(-369.000000%2C -555.000000)%22 fill%3D%22%23747272%22%3E            %3Cg id%3D%22%E4%B8%8A%E4%BC%A0%E9%99%84%E4%BB%B6%E4%B8%AD-copy-6%22 transform%3D%22translate(56.000000%2C 534.000000)%22%3E                %3Cg id%3D%22%E4%B8%8B%E8%BD%BD-copy%22 transform%3D%22translate(312.000000%2C 20.000000)%22%3E                    %3Cpath d%3D%22M8.81079102%2C8.49228232 L11.0575929%2C6.23659883 C11.367661%2C5.92438892 11.8514298%2C5.89865471 12.1342183%2C6.18304917 C12.4189783%2C6.46942638 12.3934758%2C6.95251315 12.0816605%2C7.26648227 L8.65828197%2C10.7033935 C8.57058276%2C10.8187868 8.45021995%2C10.9080019 8.31097304%2C10.9572592 C8.23162324%2C10.986943 8.14990291%2C11.0008681 8.06879562%2C10.9999582 C8.06613072%2C10.999986 8.0634625%2C11 8.06079102%2C11 C8.05811953%2C11 8.05545131%2C10.999986 8.05278641%2C10.9999582 C7.97167912%2C11.0008681 7.88995879%2C10.986943 7.81060899%2C10.9572592 C7.67136208%2C10.9080019 7.55099928%2C10.8187868 7.46330006%2C10.7033935 L4.03992152%2C7.26648227 C3.72810619%2C6.95251315 3.70260373%2C6.46942638 3.98736375%2C6.18304917 C4.27015222%2C5.89865471 4.75392098%2C5.92438892 5.06398917%2C6.23659883 L7.31079102%2C8.49228232 L7.31079102%2C1.75 C7.31079102%2C1.33578644 7.64657745%2C1 8.06079102%2C1 C8.47500458%2C1 8.81079102%2C1.33578644 8.81079102%2C1.75 L8.81079102%2C8.49228232 Z M15%2C11.0225156 L15%2C13 C15%2C14.1045695 14.1045695%2C15 13%2C15 L3%2C15 C1.8954305%2C15 1%2C14.1045695 1%2C13 L1%2C11 L1.00152941%2C11 C1.00051495%2C10.9840173 1%2C10.9678989 1%2C10.9516602 C1%2C10.5365365 1.33652425%2C10.2000122 1.75164795%2C10.2000122 C2.16677165%2C10.2000122 2.5032959%2C10.5365365 2.5032959%2C10.9516602 C2.5032959%2C10.9755555 2.50218087%2C10.9991903 2.5%2C11.0225156 L2.5%2C12.5 C2.5%2C13.0522847 2.94771525%2C13.5 3.5%2C13.5 L12.5%2C13.5 C13.0522847%2C13.5 13.5%2C13.0522847 13.5%2C12.5 L13.5%2C11 L13.5015294%2C11 C13.5005149%2C10.9840173 13.5%2C10.9678989 13.5%2C10.9516602 C13.5%2C10.5365365 13.8365242%2C10.2000122 14.2516479%2C10.2000122 C14.6667716%2C10.2000122 15.0032959%2C10.5365365 15.0032959%2C10.9516602 C15.0032959%2C10.9755555 15.0021809%2C10.9991903 15%2C11.0225156 Z%22 id%3D%22%E4%B8%8B%E8%BD%BD%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.pk-view-container .ct-attachment .download .btn-download:hover,.ProseMirror .ct-attachment .download .btn-download:hover{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2214px%22 height%3D%2214px%22 viewBox%3D%220 0 14 14%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E4%B8%8B%E8%BD%BD copy%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%99%84%E4%BB%B6%E6%B7%BB%E5%8A%A0%E5%A4%8D%E5%88%B6%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(-369.000000%2C -555.000000)%22 fill%3D%22%233d91f2%22%3E            %3Cg id%3D%22%E4%B8%8A%E4%BC%A0%E9%99%84%E4%BB%B6%E4%B8%AD-copy-6%22 transform%3D%22translate(56.000000%2C 534.000000)%22%3E                %3Cg id%3D%22%E4%B8%8B%E8%BD%BD-copy%22 transform%3D%22translate(312.000000%2C 20.000000)%22%3E                    %3Cpath d%3D%22M8.81079102%2C8.49228232 L11.0575929%2C6.23659883 C11.367661%2C5.92438892 11.8514298%2C5.89865471 12.1342183%2C6.18304917 C12.4189783%2C6.46942638 12.3934758%2C6.95251315 12.0816605%2C7.26648227 L8.65828197%2C10.7033935 C8.57058276%2C10.8187868 8.45021995%2C10.9080019 8.31097304%2C10.9572592 C8.23162324%2C10.986943 8.14990291%2C11.0008681 8.06879562%2C10.9999582 C8.06613072%2C10.999986 8.0634625%2C11 8.06079102%2C11 C8.05811953%2C11 8.05545131%2C10.999986 8.05278641%2C10.9999582 C7.97167912%2C11.0008681 7.88995879%2C10.986943 7.81060899%2C10.9572592 C7.67136208%2C10.9080019 7.55099928%2C10.8187868 7.46330006%2C10.7033935 L4.03992152%2C7.26648227 C3.72810619%2C6.95251315 3.70260373%2C6.46942638 3.98736375%2C6.18304917 C4.27015222%2C5.89865471 4.75392098%2C5.92438892 5.06398917%2C6.23659883 L7.31079102%2C8.49228232 L7.31079102%2C1.75 C7.31079102%2C1.33578644 7.64657745%2C1 8.06079102%2C1 C8.47500458%2C1 8.81079102%2C1.33578644 8.81079102%2C1.75 L8.81079102%2C8.49228232 Z M15%2C11.0225156 L15%2C13 C15%2C14.1045695 14.1045695%2C15 13%2C15 L3%2C15 C1.8954305%2C15 1%2C14.1045695 1%2C13 L1%2C11 L1.00152941%2C11 C1.00051495%2C10.9840173 1%2C10.9678989 1%2C10.9516602 C1%2C10.5365365 1.33652425%2C10.2000122 1.75164795%2C10.2000122 C2.16677165%2C10.2000122 2.5032959%2C10.5365365 2.5032959%2C10.9516602 C2.5032959%2C10.9755555 2.50218087%2C10.9991903 2.5%2C11.0225156 L2.5%2C12.5 C2.5%2C13.0522847 2.94771525%2C13.5 3.5%2C13.5 L12.5%2C13.5 C13.0522847%2C13.5 13.5%2C13.0522847 13.5%2C12.5 L13.5%2C11 L13.5015294%2C11 C13.5005149%2C10.9840173 13.5%2C10.9678989 13.5%2C10.9516602 C13.5%2C10.5365365 13.8365242%2C10.2000122 14.2516479%2C10.2000122 C14.6667716%2C10.2000122 15.0032959%2C10.5365365 15.0032959%2C10.9516602 C15.0032959%2C10.9755555 15.0021809%2C10.9991903 15%2C11.0225156 Z%22 id%3D%22%E4%B8%8B%E8%BD%BD%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ProseMirror-selectednode .ct-attachment{border:1px solid #3d91f2;box-shadow:0 0 4px 0 rgba(0,0,0,.1),0 3px 6px 0 rgba(0,0,0,.14);background-color:#fff}';
styleInject(css_248z$1);

function _assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$2(self);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
var _typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$2(this, result);
    };
}
var __generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var idMap = {};
var UPLOAD_PREFIX = classNamePrefix("attachment-placeholder");
var AttachmentExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$2(AttachmentExtension, NodeExtension);
    var _super = _createSuper$2(AttachmentExtension);
    function AttachmentExtension() {
        _classCallCheck$2(this, AttachmentExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.nodeViews = AttachmentView;
        return _this;
    }
    var _proto = AttachmentExtension.prototype;
    _proto.plugin = function plugin() {
        return new Plugin(UploaderOption({
            key: pluginKey,
            props: {
                handleClick: function(view, pos, e) {
                    // 将已经选中的上传中元素取消选中
                    var preSelected = document.querySelector(".".concat(UPLOAD_PREFIX, '[data-type="ct-progress"].selected'));
                    if (preSelected) {
                        preSelected.classList.remove("selected");
                    }
                    // 选中上传中的元素
                    var target = e.target;
                    var uploadingNode = target.closest(".".concat(UPLOAD_PREFIX, '[data-type="ct-progress"]'));
                    if (uploadingNode) {
                        var state = view.state, dispatch = view.dispatch;
                        var selection = TextSelection.create(state.doc, pos, pos + 1);
                        dispatch(state.tr.setSelection(selection));
                        uploadingNode.classList.add("selected");
                        return true;
                    }
                    return false;
                }
            }
        }, {
            createUploadMask: createPlaceholder(idMap)
        }));
    };
    _proto.commands = function commands(param) {
        var getState = param.getState, providers = param.providers, editorEventEmitter = param.editorEventEmitter, schema = param.schema;
        var _this = this;
        return {
            isDisabled: function() {
                return function() {
                    return !canInsertTypes(getState());
                };
            },
            upload: function(files) {
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    var selectedFiles = files ? Promise.resolve(files) : selectFile({
                        accept: "*/*",
                        multiple: true
                    });
                    var _this1 = _this;
                    selectedFiles.then(function() {
                        var _ref = _asyncToGenerator$1(function(fileList) {
                            var _tmp, i;
                            return __generator$1(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = provider.onSelectFiles;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            provider.onSelectFiles(fileList)
                                        ];
                                    case 1:
                                        _tmp = !_state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (_tmp) {
                                            view.focus();
                                            return [
                                                2
                                            ];
                                        }
                                        for(i = 0; i < fileList.length; i++){
                                            onUpload({
                                                view: view,
                                                provider: provider,
                                                idMap: idMap,
                                                eventEmitter: editorEventEmitter,
                                                nodeType: schema.nodes[_this1.name]
                                            })(fileList[i]);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(fileList) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return true;
                };
            },
            // 在指定位置插入图片，用于数据清洗功能
            insert: function(param) {
                var customUpload = param.customUpload, pos = param.pos;
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    onUpload({
                        view: view,
                        provider: provider,
                        idMap: idMap,
                        pos: pos,
                        eventEmitter: editorEventEmitter,
                        nodeType: schema.nodes[_this.name]
                    })(customUpload);
                    return true;
                };
            }
        };
    };
    _createClass(AttachmentExtension, [
        {
            key: "name",
            get: function get() {
                return "attachment";
            }
        }
    ]);
    return AttachmentExtension;
}(NodeExtension);

export { AttachmentExtension };
//# sourceMappingURL=index.js.map
